import React, { useState } from 'react'
import { Page, Card, Icon, Button } from '@shopify/polaris';
import { useDispatch, useSelector } from 'react-redux';
import { EditMinor, ViewMinor } from '@shopify/polaris-icons';
import ModalComponent from '../../ModalComponent'
import VendorForm from '../VendorForm'
import axios from 'axios';
import actionTypes from '../../../store/actionTypes';
import Loader from '../../Loader';
import Summary from '../../PurchaseOrders/Summary';
import './style.css'

function VendorsList() {

    const { saveSuppliers, saveSummaryOrders } = actionTypes
    const { ConfigReducer, SupplierReducer, POReducer } = useSelector(state => state)
    const { serverLink, shopId } = ConfigReducer
    const { suppliers, supplier } = SupplierReducer
    const { summaryOrders } = POReducer
    const dispatch = useDispatch()

    const emptySupplier = {
        id: '',
        shopId: shopId,
        name: '',
        website: '',
        phone: '',
        stockMessage: '',
        sendEmail: '',
        email: '',
        accountNumber: '',
        enabled: '',
        autoSubmit: '',
        address: '',
        replyEmail: '',
    }

    const [Saving, setSaving] = useState(false)
    const [FetchingProducts, setFetchingProducts] = useState(false)
    const [RefreshingVendors, setRefreshingVendors] = useState(false)
    const [SupplierEdit, setSupplierEdit] = useState({ active: false, data: emptySupplier })
    const [Error, setError] = useState({ name: '', phone: '', email: '', replyEmail: '', address: '' })

    const fetchingStyle = {
        width: "20px",
        height: "20px",
        borderWidth: "4px",
        borderStyle: "solid",
        borderColor: "#008060 #008060 #F6F6F7 #F6F6F7",
    }

    const rows = suppliers.map((supplier, i) => {
        return <tr key={i} className="tr">
            <td className="td">{i + 1}</td>
            <td className="td">{supplier.accountNumber !== null ? supplier.accountNumber : "-"}</td>
            <td className="td">{supplier.name}</td>
            <td className="td">{supplier.phone !== null ? supplier.phone : "-"}</td>
            <td className="td">{supplier.email !== null ? supplier.email : "-"}</td>
            <td className="td">{supplier.enabled !== null ? (supplier.enabled ? 'Active' : "Non-Active") : "-"}</td>
            <td className="td">{supplier.autoSubmit !== null ? (supplier.autoSubmit ? 'Active' : "Non-Active") : "-"}</td>
            <td className="td" style={{ textAlign: 'center' }}>
                <Button outline onClick={() => handleOpen(supplier)}><Icon source={EditMinor} color="base" /></Button>
                <Button outline onClick={() => fetchSupplierBaseProducts(supplier.id)}>{FetchingProducts[supplier.id] ? <Loader style={fetchingStyle} /> : <Icon source={ViewMinor} color="base" />}</Button>
            </td>
        </tr >
    })

    const handleOpen = data => setSupplierEdit({ active: true, data })
    const handleClose = () => {
        setSupplierEdit({ active: false, data: emptySupplier })
        setError({ name: '', phone: '', email: '', replyEmail: '', address: '' })
    }
    const refreshVendors = () => {
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            setRefreshingVendors(true)
            const options = {
                method: 'GET',
                url: `${serverLink}/suppliers/${shopId}`,
            }
            axios(options)
                .then(({ data }) => {
                    setRefreshingVendors(false)
                    dispatch({ type: saveSuppliers, payload: data })
                })
                .catch(error => {
                    setRefreshingVendors(false)
                    console.log(error)
                })
        } else {
            console.log('Data can not be retrieved, Check Your Internet Connection!');
            alert('Data can not be retrieved, Check Your Internet Connection!');
        }
    }
    const handleSave = vendorData => {
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            setSaving(true)
            const options = {
                method: vendorData.id === '' ? 'POST' : 'PUT',
                url: `${serverLink}/suppliers`,
                data: vendorData
            }
            axios(options)
                .then(({ data }) => {
                    setSaving(false)
                    if (data.status === 'saved') {
                        dispatch({ type: saveSuppliers, payload: [...suppliers, data.res] })
                    } else if (data.status === 'updated') {
                        const sups = suppliers
                        let index;
                        for (const i in sups) {
                            if (sups[i].id === data.res.id) {
                                index = i
                            }
                        }
                        sups.splice(index, 1, vendorData);
                        dispatch({ type: saveSuppliers, payload: sups })
                    }
                    handleClose()
                })
                .catch(error => {
                    setSaving(false)
                    console.log(error)
                })
        } else {
            console.log('Data can not be saved, Check Your Internet Connection!');
            alert('Data can not be saved, Check Your Internet Connection!');
        }
    }
    const fetchSupplierBaseProducts = supplierId => {
        const ifConnected = window.navigator.onLine;
        if (ifConnected) {
            setFetchingProducts({ [supplierId]: true })
            const options = {
                method: 'GET',
                url: `${serverLink}/order/poItems/${supplierId}/${shopId}`,
            }
            axios(options).then(({ data }) => {
                setFetchingProducts({ [supplierId]: false })
                if (data.length > 0) {
                    dispatch({ type: saveSummaryOrders, payload: data })
                } else {
                    alert('No Submitted Order!')
                }
            }).catch(error => {
                setFetchingProducts({ [supplierId]: false })
                console.log("error", error)
            })
        } else {
            console.log('Data can not be saved, Check Your Internet Connection!');
            alert('Data can not be saved, Check Your Internet Connection!');
        }
    }

    const loaderStyle = {
        width: "20px",
        height: "20px",
        borderWidth: "4px",
        borderStyle: "double solid solid",
        borderColor: "white",
    }

    return summaryOrders.length > 0 ? <Summary
        summaryOrders={summaryOrders}
    /> : <Page
        fullWidth
        title="Suppliers List"
        primaryAction={{
            content: RefreshingVendors ? <Loader style={loaderStyle} /> : 'Refresh Suppliers',
            onAction: () => refreshVendors(),
        }}
        secondaryActions={[{
            content: 'Add Supplier',
            onAction: () => handleOpen(emptySupplier),
        }]}
    >
        <Card subdued>
            <Card.Section>
                <div className='tableParent'>
                    <table className="vendorTable" style={{ overflowX: 'auto' }}>
                        <thead className="vendorTableHead">
                            <tr>
                                <th className="th">#</th>
                                <th className="th">A/C</th>
                                <th className="th">Name</th>
                                <th className="th">Phone</th>
                                <th className="th">Email</th>
                                <th className="th">Status</th>
                                <th className="th">Auto Submit</th>
                                <th className="th" style={{ textAlign: 'center' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                rows
                            }
                        </tbody>
                    </table>
                </div>
            </Card.Section>
        </Card>
        <ModalComponent
            large={false}
            modalTitle={SupplierEdit.data.id === '' ? 'New Supplier' : 'Edit Supplier'}
            active={SupplierEdit.active}
            handleClose={handleClose}
            primaryAction={{
                content: Saving ? <Loader style={loaderStyle} /> : (SupplierEdit.data.id === '' ? 'Save Supplier' : 'Update Supplier'),
                onAction: () => {
                    if (supplier.name !== '' && supplier.phone !== '' && supplier.email !== '' && supplier.replyEmail !== '' && supplier.address !== '') {
                        handleSave(supplier)
                    } else {
                        setError({
                            ...Error,
                            name: supplier.name === '' ? 'Name is required!' : '',
                            phone: supplier.phone === '' ? 'Phone is required!' : '',
                            email: supplier.email === '' ? 'Email is required!' : '',
                            replyEmail: supplier.replyEmail === '' ? 'Reply-to email is required!' : '',
                            address: supplier.address === '' ? 'Address is required!' : ''
                        })
                    }
                }
            }}
            secondaryActions={{
                content: 'Cancel',
                onAction: handleClose,
                destructive: true
            }}
            component={<VendorForm supplier={SupplierEdit.data} error={Error} />}
        />
    </Page >
}

export default VendorsList